/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~cartzillagb/util'

class BlogPostPlaceholder extends Component {

	render() {
		const {
			postsToShow,
			postperSlide,
		} = this.props

		const output = (
			<div className={ classnames( [
				'blog-placeholder',
				'row',
				'list-unstyled',
				'no-gutters',
				'my-6',
			], {} ) }>
				{ range( 1, ( postsToShow < 3 ? postsToShow : postperSlide ) + 1 ).map( i => {
					return(
						<div className={ `blog col-sm-12 col-md-4 col-lg-${12/postperSlide} mb-5` } key={ `blog-${i}` }>
							<div className="card">
								<div className="card-img-top d-block overflow-hidden position-relative w-100" style={ {height:'350px' } }>
									<div className="iframe-full-height bg-muted"></div>
								</div>
								<div className="card-body">
									<h2 className="h6 blog-entry-title progress w-50 mb-3"></h2>
									<p className="font-size-sm progress w-25"></p>
									<div className="font-size-xs text-nowrap">
									</div>
								</div>
							</div>
						</div>
					)
				} ) }
			</div>
		)

		return output
	}
}

export default BlogPostPlaceholder